module.exports = __webpack_public_path__ + "media/images/redesign-images/fraternity-new/frat-day-poster-6efad0390607d64d7d0331e823692151.jpg";